.rootWrapper {
  :global(.ant-dropdown-menu .ant-dropdown-menu-item.ant-dropdown-menu-item-disabled) {
    cursor: text;
    color: var(--b-100);
    padding-bottom: var(--ant-size-sm);
    font-weight: bold;
    font-size: var(--ant-size-sm);
  }
}

.avatar {
  width: 32px;
  max-width: none;
  object-fit: cover;
}
